// src/lib/queryClient.ts
import { QueryClient, QueryCache } from "@tanstack/react-query";
import { parseApiError, routeError, type ErrorContext } from "@/lib/errors";
import { useSessionStore } from "@/stores/sessionStore";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      const context = (query.meta?.errorContext as ErrorContext) ?? "background";
      const parsed = parseApiError(error);
      const rendering = routeError(parsed, context);

      if (rendering.type === "session-modal") {
        useSessionStore.getState().setExpired(true);
        return;
      }

      // toast and silent handled by components or ignored
      if (rendering.type === "silent") {
        console.warn("[query error]", parsed.code, parsed.message);
      }
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        const parsed = parseApiError(error);
        // Never retry 4xx
        if (parsed.status >= 400 && parsed.status < 500) return false;
        // Retry 5xx + network max 2 times
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
